import(/* webpackMode: "eager" */ "/app/app/[lang]/(public)/(pages)/pages/pricing/page.tsx");
